import React from 'react';
import './RankInsigniaVertical.css';

/**
 * Static rank insignia only (not win progress).
 * Ranks without a leaf: diamonds in a column only.
 * Ranks with silver/gold leaf: gems centered inside the leaf image.
 */
export const RANK_INSIGNIA = {
  second_lieutenant: { leaf: null, gem: 'diamond', gemCount: 1 },
  first_lieutenant: { leaf: null, gem: 'diamond', gemCount: 2 },
  captain: { leaf: null, gem: 'diamond', gemCount: 3 },
  major: { leaf: 'silver', gem: 'diamond', gemCount: 1 },
  lieutenant_colonel: { leaf: 'silver', gem: 'diamond', gemCount: 2 },
  colonel: { leaf: 'silver', gem: 'diamond', gemCount: 3 },
  brigadier_general: { leaf: 'gold', gem: 'topaz', gemCount: 1 },
  major_general: { leaf: 'gold', gem: 'topaz', gemCount: 2 },
  lieutenant_general: { leaf: 'gold', gem: 'topaz', gemCount: 3 },
  general: { leaf: 'gold', gem: 'topaz', gemCount: 4 }
};

export function RankInsigniaVertical({ rankKey }) {
  const cfg = RANK_INSIGNIA[rankKey];
  if (!cfg) {
    throw new Error(`RankInsigniaVertical: unknown rankKey for insignia: ${rankKey}`);
  }

  const gemSrc = cfg.gem === 'topaz' ? '/ranking/topaz.png' : '/ranking/diamond.png';
  const leafSrc =
    cfg.leaf === 'gold' ? '/ranking/gold.png' : cfg.leaf === 'silver' ? '/ranking/silver.png' : null;

  const gems = Array.from({ length: cfg.gemCount }, (_, i) => (
    <img
      key={i}
      src={gemSrc}
      alt=""
      className={`pvp-rank-gem pvp-rank-gem--insignia${leafSrc ? ' pvp-rank-gem--on-leaf' : ''}`}
    />
  ));

  return (
    <div className="pvp-rank-insignia-vertical" aria-hidden>
      {leafSrc ? (
        <div className="pvp-rank-insignia-leaf-wrap">
          <img src={leafSrc} alt="" className="pvp-rank-insignia-leaf-vertical" />
          <div
            className={
              cfg.gemCount >= 4
                ? 'pvp-rank-insignia-gems-on-leaf pvp-rank-insignia-gems-on-leaf--compact'
                : `pvp-rank-insignia-gems-on-leaf${
                    rankKey === 'major' ? ' pvp-rank-insignia-gems-on-leaf--major' : ''
                  }${
                    rankKey === 'lieutenant_colonel' ? ' pvp-rank-insignia-gems-on-leaf--lieutenant-colonel' : ''
                  }${
                    rankKey === 'colonel' ? ' pvp-rank-insignia-gems-on-leaf--colonel' : ''
                  }`
            }
          >
            {gems}
          </div>
        </div>
      ) : (
        <div className="pvp-rank-insignia-gems-stack pvp-rank-insignia-gems-stack--solo">{gems}</div>
      )}
    </div>
  );
}
